const env = {
  authDomain: "simplecater-staging.auth0.com",
  apiUrl: "https://iq-simplecater-api.herokuapp.com",
  clientID: "4pAwKn1UZ0JI2UgjT0cwpXUePshAr2E5",
  stripeKey: "pk_test_0gKRGyO33Sw8WYz65gubcf6F"
}

export default env


// WEBPACK FOOTER //
// ./src/config/env.js